/* eslint-disable max-len */
export const REVIEWS_DATA = {
  en: [
    {
      rating: 5,
      description:
        '"I have only had the refurbished iphone SE (2020) 64GB for about a week ...opened the box & phone looked great ... inserted my sim card ... set it up & have had NO problems at all ... VERY happy with it !"',
      picUrl: 'assets/mock_images/avatar_01.webp',
      name: 'Luci G.',
      subName: 'Highly recommended!',
      model: 'iPhone SE (2020)',
    },

    {
      rating: 5,
      description:
        '"Phone works great! Only thing is the battery is operating at 71% which isn’t surprising given its a refurbished iPhone 7. I appreciated that it arrived very fast and pretty much is exactly what I purchased."',
      picUrl: 'assets/mock_images/avatar_03.webp',
      name: 'Joseph L',
      subName: 'Exactly what I purchased.',
      model: 'iPhone 7',
    },

    {
      rating: 5,
      description:
        '"So far the biggest bang for my buck! Waited till a Flash sale! I had bought an ipad around half the price last year... worst investment untill i started using the XS Max! Thanks for the Refurbish masters."',
      picUrl: 'assets/mock_images/avatar_08.webp',
      name: 'Keith W',
      subName: 'Great deal',
      model: 'iPhone XS Max',
    },
    {
      rating: 5,
      description:
        '"With Popsy´s refurbished iPhone 11, I experienced smooth streaming and innovative features that fit my needs - a reliable choice indeed. "',
      picUrl: 'assets/mock_images/avatar_09.webp',
      name: 'Kaylee B.',
      subName: 'Smooth Streaming  with Popsy´s iPhone',
      model: 'iPhone 11',
    },
  ],
  ar: [
    {
      rating: 5,
      description:
        '"تجربة رائعة في تسوق الإلكترونيات المجددة على بوبسي. السعر معقول وتقنية الجهاز فعالة. استمتعت بوقتي الحر معهم."',
      picUrl: 'assets/mock_images/avatar_10.webp',
      name: 'نجلاء ق',
      subName: 'تسوق إلكترونيات مجددة بأسعار معقولة',
      model: 'iMac 21.5 (Late 2017)',
    },

    {
      rating: 5,
      description:
        '"- تجربة رائعة: حالة ممتازة وبالضبط كما هو موضح على الموقع. التدفق رائع وسعيد بشرائي.	"',
      picUrl: 'assets/mock_images/avatar_11.webp',
      name: 'سمر ب.	',
      subName: 'تجربة ممتازة للتسوق عبر الإنترنت',
      model: 'iPhone 12',
    },
    {
      rating: 5,
      description:
        '" تجربة رائعة ومرضية، جهاز سريع ومثالي للترفيه، بالضبط كما هو موضح. "',
      picUrl: 'assets/mock_images/avatar_05.webp',
      name: 'يحيي ب',
      subName: 'تجربة ترفيهية مثالية وسريعة',
      model: 'MacBook Air A1466 (2014)',
    },
    {
      rating: 5,
      description:
        '" تجربة ممتازة في الشراء، بطارية قوية، يسافر بسلاسة، تكنولوجيا مدهشة! "',
      picUrl: 'assets/mock_images/avatar_06.webp',
      name: 'مبشر ص',
      subName: 'تجربة شراء ممتازة ببطارية قوية وتكنولوجيا مدهشة!',
      model: 'Galaxy S20 Ultra 5G',
    },
    {
      rating: 5,
      description: '"تجربة رائعة للشراء والإعادة التدوير! "',
      picUrl: 'assets/mock_images/avatar_07.webp',
      name: 'يوسف ع',
      subName: 'تجربة شراء وإعادة تدوير رائعة!',
      model: 'iPhone SE (2022)',
    },
  ],
};
